import type { LocaleNamespace, LocaleNamespaceName } from "../types";

import address from "./address.json";
import AddressPurposeEnum from "./AddressPurposeEnum.json";
import admin from "./admin.json";
import common from "./common.json";
import DataEntryCompletionEmailOptionEnum from "./DataEntryCompletionEmailOptionEnum.json";
import DataGridColumnHeaders from "./DataGridColumnHeaders.json";
import errors from "./errors.json";
import EventTypeEnum from "./EventTypeEnum.json";
import EventTypeGroupEnum from "./EventTypeGroupEnum.json";
import glossary from "./glossary.json";
import labImport from "./labImport.json";
import months from "./months.json";
import NotificationPositionEnum from "./NotificationPositionEnum.json";
import OrganizationDateFormatEnum from "./OrganizationDateFormatEnum.json";
import RecurrenceTypeEnum from "./RecurrenceTypeEnum.json";
import ReportFrequency from "./ReportFrequency.json";
import ReportStatusEnum from "./ReportStatusEnum.json";
import ReportTimeSpanEnum from "./ReportTimeSpanEnum.json";
import ReportTypeEnum from "./ReportTypeEnum.json";
import RetentionRiskFlagTypeEnum from "./RetentionRiskFlagTypeEnum.json";
import role from "./role.json";
import SampleTypeEnum from "./SampleTypeEnum.json";
import SiteTypeEnum from "./SiteTypeEnum.json";
import SSPCMLevelEnum from "./SSPCMLevelEnum.json";
import SystemTypeEnum from "./SystemTypeEnum.json";
import TagTypeEnum from "./TagTypeEnum.json";
import WaterlyLocals from "./WaterlyLocals.json";
import yup from "./yup.json";

const localeData: Record<LocaleNamespaceName, LocaleNamespace> = {
  address,
  admin,
  common,
  DataEntryCompletionEmailOptionEnum,
  DataGridColumnHeaders,
  errors,
  AddressPurposeEnum,
  EventTypeEnum,
  EventTypeGroupEnum,
  ReportStatusEnum,
  ReportTimeSpanEnum,
  ReportTypeEnum,
  glossary,
  labImport,
  months,
  OrganizationDateFormatEnum,
  RecurrenceTypeEnum,
  RetentionRiskFlagTypeEnum,
  role,
  SampleTypeEnum,
  SiteTypeEnum,
  ReportFrequency,
  SystemTypeEnum,
  TagTypeEnum,
  WaterlyLocals,
  NotificationPositionEnum,
  yup,
  SSPCMLevelEnum,
};

export default localeData;
